var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 3C1.5 2.17157 2.17157 1.5 3 1.5H10C10.8284 1.5 11.5 2.17157 11.5 3V17C11.5 17.8284 10.8284 18.5 10 18.5H8C8 18.2239 7.77614 18 7.5 18H5.5C5.22386 18 5 18.2239 5 18.5H3C2.17157 18.5 1.5 17.8284 1.5 17V3ZM3 0.5C1.61929 0.5 0.5 1.61929 0.5 3V17C0.5 18.3807 1.61929 19.5 3 19.5H10C11.3807 19.5 12.5 18.3807 12.5 17V3C12.5 1.61929 11.3807 0.5 10 0.5H3ZM5 2C4.72386 2 4.5 2.22386 4.5 2.5C4.5 2.77614 4.72386 3 5 3H8C8.27614 3 8.5 2.77614 8.5 2.5C8.5 2.22386 8.27614 2 8 2H5Z",
    fill: "#EE8446"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.93289887d115a3164c82bf5f722dec41.svg";
export { ForwardRef as ReactComponent };